<template>
  <div v-if="!flag.notFound && article" class="contents">
    <div class="kv" :class="!article.custom_fields.image ? 'noImage' : ''">
      <img v-if="article.custom_fields.image" :src="article.custom_fields.image" :alt="article.title.rendered">
    </div>
    <div class="news-single container">
      <p class="date">{{ filterDate(article.date) }}</p>
      <h1>{{ article.title.rendered }}</h1>
      <div class="content" v-html="article.content.rendered"></div>

      <p class="toTop"><a href="/news/">ニュース一覧へ戻る</a></p>
    </div>
  </div>
  <NotFound v-else-if="flag.notFound" />
</template>

<script>
import NotFound from '@/views/NotFound.vue';
import cf from '@/mixins/commonFunctions.js';

export default {
  name: 'NewsSingle',
  mixins: [cf],
  components: {
    NotFound,
  },
  data() {
    return {
      article: null,
      slug: null,
      flag: {
        notFound: false,
      },
    };
  },
  created() {
    // idを渡したかったが渡せないようなのでslugから取得
    this.slug = this.$route.params.slug;
    this.getArticle();
  },
  methods: {
    async getArticle() {
      try {
        // slugを元に記事のIDを取得
        const articles = await this.axios({
          method: 'GET',
          url: '/genews/',
        });
        if (articles.data.length) {
          const article = articles.data.find((a) => decodeURI(a.slug) === this.slug);
          if (article) {
            this.article = article;
          } else {
            this.flag.notFound = true;
          }
        } else {
          this.flag.notFound = true;
        }
      } catch (e) {
        console.log(e.response?.data || e);
        if (e.response?.status === 404) {
          this.flag.notFound = true;
        }
      }
    },
  },
};
</script>

<style scoped lang="scss">
.news-single {
  padding-top: 1em;
}

.date {
  margin-bottom: .5em;
}

h1 {
  font-size: 1.4em;
}

.kv {
  padding-top: 80px;
  &.noImage {
    padding-top: 6em;
  }
}

@media screen and (min-width: 601px) {
  .kv {
    img {
      object-fit: cover;
      width: 100%;
      height: auto;
      max-height: 300px;
    }
    &.noImage {
      padding-top: 8em;
    }
  }
}

@media screen and (min-width: 768px) {
  .kv {
    img {
      max-height: 400px;
    }
  }
}

@media screen and (min-width: 1024px) {
  .kv {
    img {
      max-height: 500px;
    }
  }
}
</style>
